import classNames from "classnames";
import { useRouter } from "next/router";

const NavigationItem: React.FC<{
  as?: string;
  className?: string;
  highlight?: Array<string | RegExp>;
  href: string;
  onClick?: () => void;
  children?: React.ReactNode;
}> = ({ as, className, children, highlight, href, onClick }) => {
  const { pathname } = useRouter();
  const matchesHighlights = (highlight || []).some((pattern) =>
    typeof pattern === "string"
      ? pathname.startsWith(pattern)
      : pathname.match(pattern)
  );
  const matchesHref = pathname === href;

  const AsElement = (as || "li") as React.ElementType;

  return (
    <AsElement>
      <a
        data-testid="navigation-item"
        className={classNames(className, {
          "font-bold": matchesHref || matchesHighlights,
        })}
        href={href}
        onClick={onClick}
      >
        {children}
      </a>
    </AsElement>
  );
};

export default NavigationItem;
